import { useInView } from "../hooks/useInView";
import { RevealChild } from "./Reveal";
import { Link } from "react-router-dom";
import { FiArrowRight, FiMail } from "react-icons/fi";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const ConnectCTA = () => {
  const { ref, inView } = useInView({ threshold: 0.2 });

  return (
    <section className="py-12 text-light-text dark:text-text-primary" ref={ref}>
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <RevealChild visible={inView} delay={0}>
          <div className="rounded-2xl border border-light-border bg-light-surface p-8 md:p-12 dark:border-border-subtle dark:bg-surface-1">
            <div className="max-w-2xl">
              <p className="mb-3 font-mono text-xs uppercase tracking-[0.2em] text-light-muted dark:text-text-faint">
                Connect
              </p>
              <h2 className="mb-4 text-3xl md:text-4xl font-bold tracking-tight">
                Need secure cloud infrastructure,{" "}
                <span className="text-accent">sharper delivery pipelines,</span>{" "}
                or a practical DevSecOps conversation?
              </h2>
              <p className="text-base md:text-lg text-light-muted dark:text-text-muted leading-relaxed mb-8">
                Reach out for collaboration, consulting, writing, workshops, or a
                focused architecture discussion.
              </p>

              <div className="flex flex-wrap items-center gap-3 mb-10">
                <Link
                  to="/contact"
                  className="group inline-flex items-center gap-2 px-6 py-3 bg-light-text dark:bg-text-primary text-light-surface dark:text-surface-0 rounded-lg font-semibold text-sm hover:bg-light-text-secondary dark:hover:bg-text-secondary transition-colors"
                >
                  <FiMail size={14} />
                  Send a message
                  <FiArrowRight size={14} className="transition-transform group-hover:translate-x-0.5" />
                </Link>
                <a
                  href="mailto:rakeshkadam26498@gmail.com"
                  className="group inline-flex items-center gap-2 px-6 py-3 border border-light-border-strong dark:border-border-subtle text-light-text dark:text-text-primary rounded-lg font-semibold text-sm hover:border-accent/40 hover:text-accent dark:hover:text-accent transition-colors"
                >
                  Email directly
                </a>
              </div>

              <div className="flex flex-wrap items-center gap-4">
                <a
                  href="https://linkedin.com/in/rakeshkadam"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm font-medium text-light-muted hover:text-accent dark:text-text-muted dark:hover:text-accent transition-colors"
                >
                  <FaLinkedin size={16} />
                  LinkedIn
                </a>
                <a
                  href="https://github.com/rakesh-kadam"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm font-medium text-light-muted hover:text-accent dark:text-text-muted dark:hover:text-accent transition-colors"
                >
                  <FaGithub size={16} />
                  GitHub
                </a>
                <a
                  href="https://x.com/notrakeshkadam"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm font-medium text-light-muted hover:text-accent dark:text-text-muted dark:hover:text-accent transition-colors"
                >
                  <FaXTwitter size={16} />
                  X / Twitter
                </a>
                <a
                  href="https://brain.rakeshkadam.me"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm font-medium text-light-muted hover:text-accent dark:text-text-muted dark:hover:text-accent transition-colors"
                >
                  Digital Brain
                </a>
              </div>
            </div>
          </div>
        </RevealChild>
      </div>
    </section>
  );
};

export default ConnectCTA;
